import tw, { styled } from 'twin.macro';

const MarkdownOrderedList = styled.ol`
  .message-type-markdown & {
    ${tw`my-0`}
    padding-left: 1rem;
  }
`;

export default MarkdownOrderedList;
